const labels = {
  All: { 'See the offering': 'Pamatyti pasiūlymą' },
  FacilityDetails: { 'Ref: Page title': 'Facility detalės', 'Ref: Review': 'Peržiūra' },
  FacilitiesList: { 'Ref: Page title': 'paslaugos', 'Ref: See details': 'Žr. Išsamią informaciją' },
};
export default labels;
